import { render, staticRenderFns } from "./Floor4.vue?vue&type=template&id=3c5df048&scoped=true"
import script from "./Floor4.vue?vue&type=script&lang=js"
export * from "./Floor4.vue?vue&type=script&lang=js"
import style0 from "./Floor4.vue?vue&type=style&index=0&id=3c5df048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5df048",
  null
  
)

export default component.exports